export const set_book_detail = "set_book_detail";
export const set_cover_link = "set_cover_link";
export const set_audio_link = "set_audio_link";
export const riset_data = "riset_data";
export const set_book = "set_book";
export const set_modal_auth = "set_modal_auth";
export const set_redirect_to = "set_redirect_to";
export const set_logout_modal = "set_logout_modal";
export const db_set_user = "db_set_user";
